import React from 'react';
import 'primereact/resources/primereact.min.css';
import './index.css'

// SVG Icons inline for simplicity
const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" fill="#007BFF">
    <path d="M5 21V7h4v14H5zM10 21V3h4v18h-4zM15 21v-9h4v9h-4z"/>
  </svg>
);

const CalcIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" fill="#FF6B35">
    <path d="M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v4h16V4H4zm0 6v2h4v-2H4zm6 0v2h4v-2h-4zm6 0v2h4v-2h-4zM4 14v2h4v-2H4zm6 0v2h4v-2h-4zm6 0v2h4v-2h-4zM4 18v2h4v-2H4zm6 0v2h4v-2h-4zm6 0v2h4v-2h-4z"/>
  </svg>
);

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" fill="#007BFF">
    <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
  </svg>
);

const ModelDetails = () => {
  return (
    <div className="prop-dashboard">
      {/* Hero Section */}
      <section className="hero-section text-center">
        <h1>Find Your Edge, Quickly.</h1>
        <h2>The Ultimate Props Dashboard</h2>
      </section>

  

      <style jsx global>{`
        body {
          background-color: #000000; /* Black background instead of dark blue */
          color: #ffffff;
          font-family: sans-serif; /* Basic font */
        }
        /* Remove PrimeReact Card specific styles if not needed */
        /* .p-card {
          background: #2d2d2d !important;
          color: #ffffff !important;
        } */
      `}</style>

      <style jsx>{`
        .prop-dashboard {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
        }

        .hero-section h1 {
          font-size: 2.5rem;
          margin-bottom: 1rem;
          color: #ff6b35;
        }

        .hero-section h2 {
          font-size: 1.8rem;
          color: #cccccc;
          margin-bottom: 2rem;
        }

        .features-list {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .feature-item {
          width: 100%;
          max-width: 800px;
          display: flex;
          align-items: flex-start;
        }

        .feature-icon {
          font-size: 2rem;
          color: #ff6b35;
        }

        .large-crown-icon {
          font-size: 3rem;
        }

        .sub-feature {
          padding-left: 2rem;
          border-left: 2px solid #ff6b35;
        }

        .orange-icon {
          color: #ff6b35 !important;
          background: transparent !important;
        }

        .orange-button {
          background-color: #ff6b35 !important;
          border-color: #ff6b35 !important;
        }

        .orange-outline {
          color: #ff6b35 !important;
          border-color: #ff6b35 !important;
        }

        /* Mobile Styles: Maintain row layout */
        @media (max-width: 768px) {
          .prop-dashboard {
            padding: 1rem;
          }
          
          .hero-section h1 {
            font-size: 2rem;
          }
          
          .hero-section h2 {
            font-size: 1.4rem;
          }
          
          /* Keep .feature-item in row direction */
          .feature-item {
            flex-direction: row; /* Ensures image remains on the left */
            align-items: center;
            text-align: left;
          }

          /* Adjust spacing if necessary */
          .feature-icon {
            margin-bottom: 0; /* Remove bottom margin since items are in a row */
            margin-right: 10px; /* You can adjust this if needed */
          }

          .sub-feature {
            padding-left: 2rem;
            border-left: 2px solid #ff6b35;
          }
        }
      `}</style>
    </div>
  );
};

export default ModelDetails;

// NOTE: Remember to replace the placeholder icons (ChartIcon, CalculatorIcon, SearchIcon)
// with your actual icon components or elements (e.g., from an icon library or SVG files).
// You will also need to potentially adjust paths if your icons are stored locally.
